
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Company, User } from '@/generated/graphql';
import BaseSidebar from '@/components/sidebar/BaseSidebar.vue';
import Tooltip from '@/components/common/Tooltip.vue';
import UiButton from '@/components/button/ui-button.vue';
import { ISidebarNavDataChild } from '@/data/sidebar';
import OptionalAccessSection from '@/entities/OptionalAccessSection';
import Roles from '@/entities/Roles';
import TooltipVariants from '@/entities/TooltipVariants';
import CompanyMarketplaceAccessType from '@/entities/CompanyMarketplaceAccessType';
import OptionalMarketplace from '@/components/sidebar/optionalSidebarItems/OptionalMarketplace.vue';

@Component({
	components: {
		UiButton,
		Tooltip,
		BaseSidebar,
		OptionalMarketplace,
	},
})
export default class ExtendedSidebar extends Vue {
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Object, default: undefined }) readonly company?: Company;
	@Prop({ type: Boolean, default: false }) readonly sidebarOpened!: boolean;

	TooltipVariants = TooltipVariants;
	processing: boolean = false;
	requested: boolean = false;

	get isOptionalMarketplace(): boolean {
		if (this.currentUser.role !== Roles.MANAGER) {
			return false;
		}

		if (
			this.company!.marketplace_access_type ===
			CompanyMarketplaceAccessType.ALL
		) {
			return false;
		}

		const selectiveAccess =
			this.company!.marketplace_access_type ===
			CompanyMarketplaceAccessType.SELECTED;
		const accessAllowed =
			this.currentUser.manager!.marketplace_access_allowed;

		return !(selectiveAccess && accessAllowed);
	}

	isOptionalSection(section: ISidebarNavDataChild): boolean {
		switch (section.optionalAccessSection) {
			case OptionalAccessSection.MARKETPLACE:
				return this.isOptionalMarketplace;
			default:
				return false;
		}
	}

	getOptionalSectionComponent(section: ISidebarNavDataChild) {
		switch (section.optionalAccessSection) {
			case OptionalAccessSection.MARKETPLACE:
				return OptionalMarketplace;
			default:
				return;
		}
	}
}
